/* eslint-disable max-len */
import { Plugins } from '@leverege/plugin';
import { Symbols } from '@leverege/ui-mapbox-elements';

/**
 * This derives from the mapbox Symbols and adds symbols from
 * the plugins of type 'MapBoxSymbols'
 */
export default class SymbolSet extends Symbols {
  constructor(onReady, opts) {
    super(onReady, opts);
    const plgs = Plugins.get('MapSymbol');
    let normal = false;
    let selected = false;
    let rollover = false;
    let alert = false;
    plgs.forEach(p => {
      const {
        id,
        name,
        mapsTo,
        ...rest
      } = p;
      if (mapsTo) {
        this.addAlias(name, mapsTo);
      } else {
        this.addImage(name, rest);
      }
      normal = normal || name === 'normal';
      selected = selected || selected === 'selected';
      rollover = rollover || name === 'rollover';
      alert = alert || name === 'alert';
    });
    if (this.images.normal == null) {
      this.addImage('normal', {
        src: 'https://storage.googleapis.com/molten-ui-assets/generic.png',
        height: 48,
        width: 48
      });
    }
    if (this.images.rollover == null) {
      this.addImage('rollover', {
        src: 'https://storage.googleapis.com/molten-ui-assets/generic-rollover.png',
        height: 56,
        width: 56
      });
    }
    if (this.images['rollover-selected'] == null) {
      this.addImage('rollover-selected', {
        src: 'https://storage.googleapis.com/molten-ui-assets/generic-rollover-selected.png',
        height: 56,
        width: 56
      });
    }
    if (this.images.selected == null) {
      this.addImage('selected', {
        src: 'https://storage.googleapis.com/molten-ui-assets/generic-selected.png',
        height: 56,
        width: 56
      });
    }
  }

  /**
   * Returns the symbol name to use for the type and state. This
   * will return type-state unless it doesnt exist, in which case it
   * will return state
   */
  getTypeSymbol(type, subtype, rollover, selected) {
    let sym = null;
    if (subtype) {
      const pre = `${type}-${subtype}`;
      sym = this.checkForSymbol(pre, rollover, selected, false);
      if (sym) {
        return sym;
      }
    }
    sym = this.checkForSymbol(type.replace(/\./g, '-'), rollover, selected, true);
    if (sym) {
      return sym;
    }
    if (rollover && selected && this.images['rollover-selected']) {
      return this.images['rollover-selected'];
    }
    if (selected && this.images.selected) {
      return this.images.selected;
    }
    if (rollover && this.images.rollover) {
      return this.images.rollover;
    }
    if (this.images.normal) {
      return this.images.normal;
    }
    return null;
  }
  checkForSymbol(pre, rollover, selected, tryNormal) {
    let name;
    if (rollover && selected) {
      name = `${pre}-rollover-selected`;
      if (this.images[name]) {
        return this.images[name];
      }
    }
    if (selected) {
      name = `${pre}-selected`;
      if (this.images[name]) {
        return this.images[name];
      }
    }
    if (rollover) {
      name = `${pre}-rollover`;
      if (this.images[name]) {
        return this.images[name];
      }
    }
    if (tryNormal) {
      const name = `${pre}-normal`;
      if (this.images[name]) {
        return this.images[name];
      }
    }
    if (this.images[pre]) {
      return this.images[pre];
    }
    return null;
  }
}